import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const PadlockFilledIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="20" height="20" />
      <g>
        <rect x="2" y="2" width="16" height="16" />
        <g transform="translate(4.000000, 6.000000)">
          <rect x="0" y="0" width="12" height="12" />
          <path
            d="M2,3 L10,3 C11.1045695,3 12,3.8954305 12,5 L12,9 C12,10.1045695 11.1045695,11 10,11 L2,11 C0.8954305,11 1.3527075e-16,10.1045695 0,9 L0,5 C-1.3527075e-16,3.8954305 0.8954305,3 2,3 Z M6,9 C7.1045695,9 8,8.1045695 8,7 C8,5.8954305 7.1045695,5 6,5 C4.8954305,5 4,5.8954305 4,7 C4,8.1045695 4.8954305,9 6,9 Z"
            stroke={color || easilGrayXDark}
            strokeWidth="1.8"
            fill={color || easilGrayXDark}
          />
        </g>
        <path
          d="M12.1,6 C12.1,4.84020203 11.159798,3.9 10,3.9 C8.84020203,3.9 7.9,4.84020203 7.9,6 L7.9,8.1 L12.1,8.1 L12.1,6 Z M10,2.1 C12.1539105,2.1 13.9,3.84608948 13.9,6 L13.9,9.9 L6.1,9.9 L6.1,6 C6.1,3.84608948 7.84608948,2.1 10,2.1 Z"
          fill={color || easilGrayXDark}
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);
PadlockFilledIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default PadlockFilledIcon;
